import React, { useEffect, useState } from "react";
import api from '../../services/api';
import { useTranslation } from "react-i18next";

function QRCode({ link }) {
    const { t } = useTranslation();
    const [qrCode, setQrCode] = useState("");
    const [isSvg, setIsSvg] = useState(false);

    useEffect(() => {
        const fetchQrCode = async (format = "png") => {
            try {
                const response = await api.get(`${process.env.REACT_APP_API_URL}/qrcode/download`, {
                    params: { url: link, format },
                    responseType: format === "svg" ? "text" : "blob",
                });

                if (format === "svg") {
                    // For SVG, we use raw markup for preview and set the flag for download
                    setQrCode(response.data);  // raw SVG data for preview
                    setIsSvg(true);
                } else {
                    // For PNG, create an object URL directly
                    const url = URL.createObjectURL(response.data);
                    setQrCode(url);
                    setIsSvg(false);
                }
            } catch (error) {
                console.error("Error generating QR code", error);
            }
        };

        if (link) {
            fetchQrCode("svg");  // use "svg" or "png" to test both formats
        }
    }, [link]);

    const downloadQrCode = () => {
        if (!qrCode) return;

        let downloadUrl;
        if (isSvg) {
            // For SVG, create a Blob from the raw SVG markup
            const svgBlob = new Blob([qrCode], { type: "image/svg+xml" });
            downloadUrl = URL.createObjectURL(svgBlob);
        } else {
            // For PNG, use the existing Blob URL
            downloadUrl = qrCode;
        }

        // Trigger download
        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = `qrcode.${isSvg ? "svg" : "png"}`;
        downloadLink.click();

        // Clean up Blob URL if it was newly created
        if (isSvg) URL.revokeObjectURL(downloadUrl);
    };

    return (
        <div>
            {qrCode && (
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div style={{ maxWidth: "350px", margin: "20px auto" }}>
                            {isSvg ? (
                                <div dangerouslySetInnerHTML={{ __html: qrCode }} />
                            ) : (
                                <img src={qrCode} alt="QR Code" style={{ width: "100%", height: "auto" }} />
                            )}
                        </div>
                        <button className="btn btn-default btn-send btn btn-primary mt-2" onClick={downloadQrCode}>
                            {t("admin.inv.downQR")}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default QRCode;
